let _decode = null;
function _setLiteErrorDecoder(decode) {
  _decode = decode;
}
function ThrowLiteError(code, ...args) {
  const error = new Error(_decode?.(code, args) ?? `#${code}`);
  error.lite = args;
  throw error;
}

export { ThrowLiteError, _setLiteErrorDecoder };
//# sourceMappingURL=lite-error.js.map
